/**
 * PrivacySLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacySLSiteHeaderLanguages
 */

import { usePrivacySLSiteHeaderLanguagesLogic } from '@/hooks/traits/usePrivacySLSiteHeaderLanguagesLogic';
import type { PrivacySLSiteHeaderLanguagesConfig } from '@/hooks/traits/usePrivacySLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacySLPrivacyView as PrivacySLPrivacyViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PrivacySLSiteHeaderLanguagesViewProps {
  config?: Partial<PrivacySLSiteHeaderLanguagesConfig>;
}

export function PrivacySLSiteHeaderLanguagesView({ config: propsConfig }: PrivacySLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacySLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacySLPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacySL" trait="PrivacySLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu position="bottom-end" className={((([{ href: "/privacy" as const, label: "English" as const, code: "en" as const }, { code: "ar" as const, href: "/ar/privacy" as const, label: "العربية" as const }, { code: "sl" as const, href: "/sl/privacy" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} trigger={<Button label={String(__locale.toUpperCase())} size="sm" icon="globe" variant="ghost" />} items={Array.isArray(([{ label: "English" as const, href: "/privacy" as const, code: "en" as const }, { href: "/ar/privacy" as const, code: "ar" as const, label: "العربية" as const }, { href: "/sl/privacy" as const, label: "Slovenščina" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) ? (((([{ label: "English" as const, href: "/privacy" as const, code: "en" as const }, { href: "/ar/privacy" as const, code: "ar" as const, label: "العربية" as const }, { href: "/sl/privacy" as const, label: "Slovenščina" as const, code: "sl" as const }]).map((entry) => ({ icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? ""), href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} />) : null}
    </TraitScopeProvider>
  );
}

export default PrivacySLSiteHeaderLanguagesView;
